export default __webpack_public_path__ + "img/vivinter_diot-siaci.7553993f.png";